export class PerfilAcesso {

	id: number;
	nome: string;
	altera: boolean;
	consulta: boolean;
	deleta: boolean;
	insere: boolean;
	
}